import React from "react";

import { DefaultSlide, DefaultSlideType } from "./default";
import { PollSlide, PollSlideType } from "./poll";
import { ProgressSlide, ProgressSlideType } from "./progress";
import { useOpenNewsArticle } from "hooks/use-open-news-article";
import { BRIDGE_FUNCTION, OPEN_LINK } from "../../../constants/types/commands";
import { usePollContext } from "../../../stores/poll";
import { ZippyZebraProgressSlide } from "./zippy-zebra";
import { AzurePhoenixSlide, AzurePhoenixSlideType } from "./azure-phoenix";

export type HandleCTAClick = (
    props: Omit<InboxCTA, "order" | "variant">,
) => void;

export const handleCTAClick =
    (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        sendCommand: any,
        openNewsArticle: ReturnType<typeof useOpenNewsArticle>,
        openModal: ReturnType<typeof usePollContext>["actions"]["openModal"],
        title = "",
    ): HandleCTAClick =>
    ({ id, article, type, url, label, functionName, functionArgs }) => {
        if (
            type === "article" &&
            article?.section === "carouselEventPollEntry"
        ) {
            return openModal(article?.id.toString() ?? "");
        }

        if (type === "article" && article !== undefined) {
            return openNewsArticle(article?.id, title);
        }

        if (type === "bridgeFunction") {
            sendCommand(BRIDGE_FUNCTION, {
                functionName,
                functionArgs,
            });
            return;
        }

        return sendCommand(OPEN_LINK, { url, id, label });
    };

export type SlideType =
    | PollSlideType
    | ProgressSlideType
    | DefaultSlideType
    | AzurePhoenixSlideType;

export const CarouselSlide = (props: SlideType) => {
    const { type, targeting } = props;

    switch (type) {
        case "pollEntry":
            return <PollSlide slide={props} />;
        case "progressTrackerEntry":
            if (targeting?.campaignId === "zippy-zebra") {
                return <ZippyZebraProgressSlide slide={props} />;
            }

            return <ProgressSlide slide={props} />;
        case "eventEntry":
            if (targeting?.campaignId === "azure-phoenix") {
                return <AzurePhoenixSlide slide={props} />;
            }
            return <DefaultSlide slide={props} />;
        default:
            return <DefaultSlide slide={props} />;
    }
};
